<template>
  <component :is="layout">
    <router-view />
  </component>

  <div v-if="isLoading" class="loading-spinner d-flex justify-content-center align-items-center">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <MainFooter />
</template>

<script>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import LoginLayout from './layouts/LoginLayout.vue';
import MainLayout from './layouts/MainLayout.vue';
import MainLayoutInstitute from './layouts/MainLayoutInstitute.vue';
import MainLayoutHospital from './layouts/MainLayoutHospital.vue';
import RegisterLayout from './layouts/RegisterLayout.vue';
import MainFooter from './layouts/MainFooter.vue';
import loadingStore from './loading';

export default {
  name: 'App',
  components: {
    LoginLayout,
    MainLayout,
    MainLayoutInstitute,
    MainLayoutHospital,
    RegisterLayout,
    MainFooter
  },
  setup() {
    const isLoading = computed(() => loadingStore.isLoading.value);
    const route = useRoute();
    const layout = computed(() => route.meta.layout || 'MainLayout');

    onMounted(() => {
  setInterval(() => {
    fetch('/version.json')
      .then(res => res.json())
      .then(versionData => {
        const storedVersion = localStorage.getItem('app_version');
        const storedBuild = localStorage.getItem('app_build');

        const versionChanged = storedVersion !== versionData.version;
        const buildChanged = storedBuild !== versionData.build;

        if (versionChanged || buildChanged) {
          localStorage.setItem('app_version', versionData.version);
          localStorage.setItem('app_build', versionData.build);
          location.reload(); // Reload from server to get latest files
        }
      })
      .catch(err => {
        console.error('Failed to fetch version.json:', err);
      });
  }, 60000); // Check every 60 seconds
});


    return { layout, isLoading };
  }
};
</script>

<style>
.loading-spinner {
  position: fixed;
  top: 12%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  margin-top: 200px;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
